import { createColumnHelper } from "@tanstack/react-table";
import { IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const columnHelper = createColumnHelper();

const IColumnas = ({ handleDelete } : any) => {
    return [
        columnHelper.accessor("orden", {
            header: () => "Orden",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("nombreColumna", {
            header: () => "Columna",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("tipoColumna", {
            header: () => "Tipo de dato",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("accions", {
            header: () => "",
            cell: ({row}) => (
                <Tooltip onClick={() => handleDelete(row.original)} title="Eliminar">
                    <IconButton>
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            )
        }),
    ];
};

export default IColumnas;
